import { UserTrackingBaseProperties, UserTraits } from './user-tracking.model';

export abstract class UserTrackingSettingsService {
  abstract getUser(): UserTraits;
  abstract getBaseProperties(): UserTrackingBaseProperties;
}
